export const PLANT_TYPES = {
    1: {
        id: 1,
        name: `Car`,
        isVehicle: true,
        isDeleted: false,
    },
    2: {
        id: 2,
        name: `Truck`,
        isVehicle: true,
        isDeleted: false,
    },
    3: {
        id: 3,
        name: `Chainsaw`,
        isVehicle: false,
        isDeleted: false,
    },
    9: {
        id: 9,
        name: `Wheel Jack`,
        isVehicle: false,
        isDeleted: true,
    },
    10: {
        id: 10,
        name: `Axe`,
        isVehicle: false,
        isDeleted: false,
    },
    11: {
        id: 11,
        name: `Ute`,
        isVehicle: true,
        isDeleted: false,
    },
    12: {
        id: 12,
        name: `Ladder`,
        isVehicle: false,
        isDeleted: true,
    },
    13: {
        id: 13,
        name: `Chair`,
        isVehicle: false,
        isDeleted: true,
    },
    15: {
        id: 15,
        name: `Motorcycle`,
        isVehicle: true,
        isDeleted: false,
    },
    94: {
        id: 94,
        name: `Trailer`,
        isVehicle: false,
        isDeleted: false,
    },
    271: {
        id: 271,
        name: `Bike`,
        isVehicle: true,
        isDeleted: false,
    },
    277: {
        id: 277,
        name: `Banana`,
        isVehicle: false,
        isDeleted: true,
    },
    327: {
        id: 327,
        name: `Stihl Chainsaw`,
        isVehicle: false,
        isDeleted: true,
    },
};



// WEBPACK FOOTER //
// ./scripts/constants/fakeData/plantTypes.js